import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Controller, useForm } from 'react-hook-form';
import { usPhoneNumberValidation } from 'validators';
import { TextField, USPhoneNumberInput } from 'seagull';
import { validateContact } from '~/business-logic/validators';
import { useLocaleKeys } from '~/i18n';
import { connectControllerToTextField } from '~/utils/react-hook-form.utils';
import s from './TriageContactForm.module.scss';
import { PrimaryContactRowTestIds } from './TriageContactRow';
export const TriageContactForm = (param)=>{
    let { contact, onFieldChange } = param;
    var _contact_companyName, _contact_firstName, _contact_lastName, _contact_email, _contact_phone;
    const { t } = useLocaleKeys('agreementImport.triageModal.primaryContactForm');
    const phoneValidator = usPhoneNumberValidation();
    const { control } = useForm({
        mode: 'all',
        defaultValues: {
            companyName: (_contact_companyName = contact.companyName) !== null && _contact_companyName !== void 0 ? _contact_companyName : '',
            firstName: (_contact_firstName = contact.firstName) !== null && _contact_firstName !== void 0 ? _contact_firstName : '',
            lastName: (_contact_lastName = contact.lastName) !== null && _contact_lastName !== void 0 ? _contact_lastName : '',
            email: (_contact_email = contact.email) !== null && _contact_email !== void 0 ? _contact_email : '',
            phone: (_contact_phone = contact.phone) !== null && _contact_phone !== void 0 ? _contact_phone : ''
        }
    });
    const emitChange = (field, rhfOnChange)=>(e)=>{
            rhfOnChange(e);
            onFieldChange(field, e.target.value);
        };
    return /*#__PURE__*/ _jsxs("div", {
        className: s.form,
        "data-testid": "triage-contact-form",
        children: [
            /*#__PURE__*/ _jsx(Controller, {
                control: control,
                name: "firstName",
                rules: {
                    validate: validateContact.firstName
                },
                render: (renderProps)=>{
                    const connected = connectControllerToTextField(renderProps);
                    return /*#__PURE__*/ _jsx(TextField, _object_spread_props(_object_spread({}, connected), {
                        label: t.firstName(),
                        testId: PrimaryContactRowTestIds.FirstNameInput(),
                        onChange: emitChange('firstName', connected.onChange)
                    }));
                }
            }),
            /*#__PURE__*/ _jsx(Controller, {
                control: control,
                name: "lastName",
                rules: {
                    validate: validateContact.lastName
                },
                render: (renderProps)=>{
                    const connected = connectControllerToTextField(renderProps);
                    return /*#__PURE__*/ _jsx(TextField, _object_spread_props(_object_spread({}, connected), {
                        label: t.lastName(),
                        testId: PrimaryContactRowTestIds.LastNameInput(),
                        onChange: emitChange('lastName', connected.onChange)
                    }));
                }
            }),
            /*#__PURE__*/ _jsx(Controller, {
                control: control,
                name: "companyName",
                rules: {
                    validate: validateContact.companyName
                },
                render: (renderProps)=>{
                    const connected = connectControllerToTextField(renderProps);
                    return /*#__PURE__*/ _jsx(TextField, _object_spread_props(_object_spread({}, connected), {
                        label: t.companyName(),
                        testId: PrimaryContactRowTestIds.CompanyNameInput(),
                        onChange: emitChange('companyName', connected.onChange)
                    }));
                }
            }),
            /*#__PURE__*/ _jsx(Controller, {
                control: control,
                name: "email",
                rules: {
                    validate: validateContact.email
                },
                render: (renderProps)=>{
                    const connected = connectControllerToTextField(renderProps);
                    return /*#__PURE__*/ _jsx(TextField, _object_spread_props(_object_spread({}, connected), {
                        label: t.email(),
                        testId: PrimaryContactRowTestIds.EmailInput(),
                        onChange: emitChange('email', connected.onChange)
                    }));
                }
            }),
            /*#__PURE__*/ _jsx(Controller, {
                control: control,
                name: "phone",
                rules: phoneValidator,
                render: (renderProps)=>{
                    const connected = connectControllerToTextField(renderProps);
                    return /*#__PURE__*/ _jsx(USPhoneNumberInput, _object_spread_props(_object_spread({}, connected), {
                        label: t.phone(),
                        testId: PrimaryContactRowTestIds.PhoneInput(),
                        onChange: emitChange('phone', connected.onChange)
                    }));
                }
            })
        ]
    });
};
